import { makeAutoObservable } from 'mobx';
import { IBreadcrumb } from 'tkmp-lib/src/interfaces';
import { ECatalogDisplayViewType } from 'tkmp-lib/src/enums';

export class SystemStore {
    BREADCRUMBS: IBreadcrumb[] = [];
    IS_ALL_FILES_UPLOADED: boolean = false;
    CATALOG_DISPLAY_TYPE: ECatalogDisplayViewType = ECatalogDisplayViewType.Grid;
    constructor() {
        makeAutoObservable(this);
    }

    setAllFilesUploaded = (value: boolean) => {
        this.IS_ALL_FILES_UPLOADED = value;
    };
    clearBreadcrumbs = () => {
        this.BREADCRUMBS = [];
    };
    setBreadcrumbs = (value: IBreadcrumb[]) => {
        this.BREADCRUMBS = value;
    };
    toggleCatalogDisplayType = () => {
        if (this.CATALOG_DISPLAY_TYPE === ECatalogDisplayViewType.Grid)
            this.CATALOG_DISPLAY_TYPE = ECatalogDisplayViewType.List;
        else this.CATALOG_DISPLAY_TYPE = ECatalogDisplayViewType.Grid;
    };
    setCatalogDisplayType = (value: ECatalogDisplayViewType) => {
        this.CATALOG_DISPLAY_TYPE = value;
    };
}
